var SUB = SUB || {};

SUB.data = {
	questions : [
		[
			{
				question: 'At a diner for breakfast, I’m most likely to order&nbsp;…',
				description: 'Chocolate or fruit',
				answerA: 'Chocolate chip pancakes',
				answerB: 'Fruit blintzes',
				imageA: '/Content/img/quiz/chocolate_pancakes',
				imageB: '/Content/img/quiz/fruit_blintzes'
			},
			{
				question: 'At an all-you-can-eat breakfast buffet&nbsp;…',
				description: 'Indulgent or Light',
				answerA: 'I try not to get carried away.',
				answerB: 'I try everything, of course!',
				imageA: '/Content/img/quiz/light',
				imageB: '/Content/img/quiz/indulgent'
			},
			{
				question: 'Take me out to the ball game with&nbsp;…',
				description: 'Nuts or no nuts',
				answerA: 'A bag of peanuts, please.',
				answerB: 'Pop, pop, popcorn!',
				imageA: '/Content/img/quiz/peanuts',
				imageB: '/Content/img/quiz/popcorn'
			},
			{
				question: 'An ideal morning begins with&nbsp;…',
				description: 'Sweet or savory',
				answerA: 'Jelly donut',
				answerB: 'Golden, buttery hash browns',
				imageA: '/Content/img/quiz/sweet',
				imageB: '/Content/img/quiz/savory'
			},
			{
				question: 'For breakfast, you’re most likely to make&nbsp;…',
				description: 'Daring or not daring',
				answerA: 'A tomato, basil and goat cheese frittata',
				answerB: 'A piece of toast with butter',
				imageA: '/Content/img/quiz/frittata',
				imageB: '/Content/img/quiz/toast'
			}
		],
		[
			{
				question: 'In the morning, you’re most likely&nbsp;…',
				description: 'Snooze or down dog?',
				answerA: 'Hitting snooze',
				answerB: 'Hitting down dog',
				imageA: '/Content/img/quiz/snooze',
				imageB: '/Content/img/quiz/down_dog'
			},
			{
				question: 'What are mornings like for you?',
				description: '',
				answerA: 'Ughhh! I lost my keys&nbsp;… again!',
				answerB: 'I’m up and dressed before dawn!',
				imageA: '/Content/img/quiz/lost_keys',
				imageB: '/Content/img/quiz/up_before_dawn'
			},
			{
				question: 'At night, you’re most likely&nbsp;…',
				description: '',
				answerA: 'Up watching late night television',
				answerB: 'What’s late night TV?',
				imageA: '/Content/img/quiz/up_watching',
				imageB: '/Content/img/quiz/whats_late_night_tv'
			},
			{
				question: 'When you get up, you&nbsp;…',
				description: '',
				answerA: 'Sip coffee with the morning shows',
				answerB: 'I barely have time to brush my teeth',
				imageA: '/Content/img/quiz/sip_coffee',
				imageB: '/Content/img/quiz/barely_brush_teeth'
			}
		]
	],


	answers : [
		[
			{
				name: 'malted-nutty-banana',
				pattern: 'abaaa'
			},
			{
				name: 'peach-crumble',
				pattern: 'bbaab'
			},
			{
				name: 'almost-smores',
				pattern: 'abbab'
			},
			{
				name: 'peppermint-patty',
				pattern: 'aabaa'
			},
			{
				name: 'the-circus',
				pattern: 'bbaab'
			},
			{
				name: 'banana-nut',
				pattern: 'baaaa'
			},
			{
				name: 'pistachio-lemon',
				pattern: 'baaba'
			},
			{
				name: 'cinnamon-apple',
				pattern: 'babab'
			},
			{
				name: 'berry-au-lait',
				pattern: 'babaa'
			},
			{
				name: 'tropical-mermaid',
				pattern: 'babaa'
			},
			{
				name: 'kickin-crunch',
				pattern: 'babba'
			},
			{
				name: 'muesli-parfait',
				pattern: 'babab'
			},
			{
				name: 'mexican-chocolate',
				pattern: 'abbaa'
			},
			{
				name: 'grown-up-trail-mix',
				pattern: 'abaaa'
			},
			{
				name: 'just-peachy',
				pattern: 'babab'
			},
			{
				name: 'nutty-monkey',
				pattern: 'bbaab'
			}
		],
	// note: each personality type is listed twice to handle the N/A items in the matrix
	// need to present A and B variants for each N/A question
		[
			{
				name: 'morning-ninja',
				pattern: 'bbba'
			},
			{
				name: 'morning-ninja',
				pattern: 'bbbb'
			},
			{
				name: 'professional-dreamer',
				pattern: 'aaab'
			},
			{
				name: 'professional-dreamer',
				pattern: 'abab'
			},
			{
				name: 'rose-smeller',
				pattern: 'bbba'
			},
			{
				name: 'rose-smeller',
				pattern: 'abba'
			},
			{
				name: 'first-light-loather',
				pattern: 'aaab'
			},
			{
				name: 'first-light-loather',
				pattern: 'aabb'
			}
		]
	],

	profiles  : [
		{
			"class_name" : "rose-smeller",
			"full_name" : "Rose Smeller",
			"profile_bg" : "/Content/img/profiles/rose_smeller_mobile.jpg",
			"header" : "Well, this is nice&nbsp;…",
			"description" : "There are no thorns in your morning. You indulge in long showers, then merrily stroll into the sunlight to read the news and finish a Sudoku puzzle. Your coffee mug is always half full. You’ll love stopping to smell this sweetness&nbsp;…",
			"facebook_copy": "There are no thorns in your morning. You indulge in long showers, then merrily stroll into the sunlight to read the news and finish a Sudoku puzzle. Your coffee mug is always half full. Take the quiz to find out your morning personality and matching recipe. www.StirUpBreakfast.com",
			"bitly" : {
					"almost-smores"     :   "http://bit.ly/1KJ0BAg",
					"banana-nut"        :   "http://bit.ly/1MgSpHJ",
					"berry-au-lait"     :   "http://bit.ly/1O5Qoyb",
					"kickin-crunch"     :   "http://bit.ly/1UM2taU",
					"cinnamon-apple"    :   "http://bit.ly/1KfLCeW",
					"grown-up-trail-mix":   "http://bit.ly/1MgSyuN",
					"peach-crumble"     :   "http://bit.ly/1Oj4Y4C",
					"just-peachy"       :   "http://bit.ly/1ESCNaW",
					"malted-nutty-banana":  "http://bit.ly/1OH9VSI",
					"mexican-chocolate"  :  "http://bit.ly/1Kdd4ps",
					"muesli-parfait"     :  "http://bit.ly/1Nu1UUj",
					"nutty-monkey"       :  "http://bit.ly/1Oj5e3G",
					"peppermint-patty"   :  "http://bit.ly/1MgSNpJ",
					"pistachio-lemon"    :  "http://bit.ly/1ijs4fG",
					"the-circus"         :  "http://bit.ly/1ESDzEW"
			}
		},
		{
			"class_name" : "morning-ninja",
			"full_name" : "Morning Ninja",
			"profile_bg" : "/Content/img/profiles/morning_ninja_mobile.jpg",
			"header" : "WOWEEE!",
			"description" : "You don’t sweat the morning. You often wake up before the alarm. Always 10 steps ahead of everyone else — moving stealthily, while getting more done in the a.m. than most people do in a full day. Since you’re wide-awake, get ready to toast, chop and top. Hiiiiiiii-­yaaaa!",
			"bitly" : {
				"almost-smores"     :   "http://bit.ly/1K2xBQD",
				"banana-nut"        :   "http://bit.ly/1K2xKmZ",
				"berry-au-lait"     :   "http://bit.ly/1VRSCmf",
				"kickin-crunch"     :   "http://bit.ly/1iCLf3P",
				"cinnamon-apple"    :   "http://bit.ly/1J3eD8y",
				"grown-up-trail-mix":   "http://bit.ly/1L6M9Rk",
				"peach-crumble"     :   "http://bit.ly/1Lo98TL",
				"just-peachy"       :   "http://bit.ly/1NmDXN1",
				"malted-nutty-banana":  "http://bit.ly/1OHiEoc",
				"mexican-chocolate"  :  "http://bit.ly/1MgXEHa",
				"muesli-parfait"     :  "http://bit.ly/1MgXFep",
				"nutty-monkey"       :  "http://bit.ly/1Nu8SZh",
				"peppermint-patty"   :  "http://bit.ly/1K1fvMH",
				"pistachio-lemon"    :  "http://bit.ly/1Nu8XvW",
				"the-circus"         :  "http://bit.ly/1KJ5qcX"
			}
		},
		{
			"class_name" : "professional-dreamer",
			"full_name" : "Professional Dreamer",
			"profile_bg" : "/Content/img/profiles/professional_dreamer_mobile.jpg",
			"header" : "Congratulations&nbsp;… Zzzzzz!",
			"description" : "Let’s be honest, you’ve probably worn out dream catchers. You set multiple alarms and none of them really phase you. Pressing snooze is not a decision – it’s a way of life. Now roll out of bed and try this dreamy recipe&nbsp;…",
			"bitly" : {
				"almost-smores"     :   "http://bit.ly/1ijC08X",
				"banana-nut"        :   "http://bit.ly/1KJ6fT4",
				"berry-au-lait"     :   "http://bit.ly/1Q75RvC",
				"kickin-crunch"     :   "http://bit.ly/1K2BFAe",
				"cinnamon-apple"    :   "http://bit.ly/1KfTyNu",
				"grown-up-trail-mix":   "http://bit.ly/1iCNq7u",
				"peach-crumble"     :   "http://bit.ly/1VRUNpX",
				"just-peachy"       :   "http://bit.ly/1FCgykf",
				"malted-nutty-banana":  "http://bit.ly/1ijC9ZY",
				"mexican-chocolate"  :  "http://bit.ly/1ESRk6k",
				"muesli-parfait"     :  "http://bit.ly/1VRUUlk",
				"nutty-monkey"       :  "http://bit.ly/1MgYZxG",
				"peppermint-patty"   :  "http://bit.ly/1K1h2lO",
				"pistachio-lemon"    :  "http://bit.ly/1O5W77h",
				"the-circus"         :  "http://bit.ly/1MgZ5p8"
			}
		},
		{
			"class_name" : "first-light-loather",
			"full_name" : "First Light Loather",
			"profile_bg" : "/Content/img/profiles/first_light_loather_mobile.jpg",
			"header" : "It’s going to be OK&nbsp;…",
			"description" : "Mornings are not for you. You throw mad shade at the sun. And your bedroom is probably made of blackout blinds. No matter how much rest you get, the sun seems to come too soon. But this bowl might just be a game changer for you.",
			"bitly" : {
				"almost-smores"     :   "http://bit.ly/1NmEWN5",
				"banana-nut"        :   "http://bit.ly/1iCMyzK",
				"berry-au-lait"     :   "http://bit.ly/1K2AOzH",
				"kickin-crunch"     :   "http://bit.ly/1OHjCR9",
				"cinnamon-apple"    :   "http://bit.ly/1OjcTir",
				"grown-up-trail-mix":   "http://bit.ly/1UMasVo",
				"peach-crumble"     :   "http://bit.ly/1Q75r8C",
				"just-peachy"       :   "http://bit.ly/1VRUrQ2",
				"malted-nutty-banana":  "http://bit.ly/1Q75FfQ",
				"mexican-chocolate"  :  "http://bit.ly/1Ojd6lB",
				"muesli-parfait"     :  "http://bit.ly/1KdhWe6",
				"nutty-monkey"       :  "http://bit.ly/1OHk7uH",
				"peppermint-patty"   :  "http://bit.ly/1J3fypB",
				"pistachio-lemon"    :  "http://bit.ly/1KfTq0r",
				"the-circus"         :  "http://bit.ly/1UMaHQf"
			}
		},
		{
			"class_name" : "no_profile",
			"bitly" : {
				"almost-smores"     :   "http://bit.ly/1FChxRo",
				"banana-nut"        :   "http://bit.ly/1Q7771I",
				"berry-au-lait"     :   "http://bit.ly/1KJ70vo",
				"kickin-crunch"     :   "http://bit.ly/1NuawKD",
				"cinnamon-apple"    :   "http://bit.ly/1ijCZWs",
				"grown-up-trail-mix":   "http://bit.ly/1KJ72mW",
				"peach-crumble"     :   "http://bit.ly/1K1hZKU",
				"just-peachy"       :   "http://bit.ly/1NuaClt",
				"malted-nutty-banana":  "http://bit.ly/1QteC3L",
				"mexican-chocolate"  :  "http://bit.ly/1ESS9fC",
				"muesli-parfait"     :  "http://bit.ly/1MgZUhI",
				"nutty-monkey"       :  "http://bit.ly/1iCOSXx",
				"peppermint-patty"   :  "http://bit.ly/1F2kfVp",
				"pistachio-lemon"    :  "http://bit.ly/1OjfmcN",
				"the-circus"         :  "http://bit.ly/1KfVcyv"
			}
		}
	]
};